import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { StudioFlowColors, StudioFlowRadii } from '../studioFlowTheme';

export const FlowTextField: React.FC<TextFieldProps> = (props) => (
  <TextField
    {...props}
    fullWidth
    variant="outlined"
    sx={{
      '& .MuiOutlinedInput-root': {
        borderRadius: `${StudioFlowRadii.input}px`,
        fontSize: 15,
        fontFamily: StudioFlowColors.bodyFontFamily,
        letterSpacing: '-0.15px',
        bgcolor: StudioFlowColors.background,
        '& fieldset': {
          borderColor: StudioFlowColors.border,
        },
        '&:hover fieldset': {
          borderColor: StudioFlowColors.title,
        },
        '&.Mui-focused fieldset': {
          borderColor: StudioFlowColors.primary,
          borderWidth: 1,
        },
        '& input': {
          color: StudioFlowColors.title,
          '&::placeholder': {
            color: StudioFlowColors.accent,
            opacity: 1,
          },
        },
      },
      '& .MuiInputLabel-root': {
        color: StudioFlowColors.accent,
        fontFamily: StudioFlowColors.bodyFontFamily,
        fontSize: 15,
        letterSpacing: '-0.15px',
        backgroundColor: StudioFlowColors.background,
        px: '6px',
        zIndex: 1,
      },
      '& .MuiInputLabel-root.Mui-focused': {
        color: StudioFlowColors.primary,
      },
      '& .MuiOutlinedInput-root textarea': {
        color: StudioFlowColors.title,
      },
      ...props.sx,
    }}
  />
);
